export const STEPS = {
  DATA_PROCESSING_POLICY: 'DATA_PROCESSING_POLICY',
  INPUT_PERSONAL_DATA: 'INPUT_PERSONAL_DATA',
  TEST_DESCRIPTION: 'TEST_DESCRIPTION',
  TEST: 'TEST',
  FINISH: 'FINISH',
};
